module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/cloud-download-outline-55be7cd16d1276c34d35114844c6bc05.svg";